import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      marginTop: 15,
    },
  },
}));

export default useStyles;
